var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"width":"100px","height":"100px"},attrs:{"viewBox":"-2 -2 28 28"}},[_c('path',{attrs:{"fill":"#142454","d":"M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M18,20V9H13V4H6V20H18M12,19L8,15H10.5V12H13.5V15H16L12,19Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }